import { Notification } from "@shared/types";
import { groupBy } from "lodash";
import { sharedLib } from "@shared/services/shared.service";

export const getAggregateNotificationsArrays = (
  notifications: Notification[]
) => {
  let aggregateNotificationsArrays: Notification[][] = [];
  const groupedNotifications = groupBy(notifications, "main_component_id");
  for (let mainComponentId in groupedNotifications) {
    const groupedNotification = groupedNotifications?.[mainComponentId];
    if (mainComponentId === "null" || mainComponentId === "undefined") {
      groupedNotification.map((notification) => {
        aggregateNotificationsArrays.push([notification]);
      });
    } else {
      const sortedNotificationItems = groupedNotification
        .sort((a, b) => b.time - a.time)
        .slice(0, 5);
      aggregateNotificationsArrays.push(sortedNotificationItems);
    }
  }

  return aggregateNotificationsArrays;
};

export const addTrailingDots = (str: string, show: boolean) => {
  return show ? str.concat("...") : str;
};

export const updateNotificationsData = (newNotification: Notification) => {
  return sharedLib.sharedApi.notifications.util.updateQueryData(
    "getNotifications",
    undefined,
    (notifications) => {
      const existNotificationIndex = notifications.findIndex(
        (groupedNotification) =>
          newNotification.main_component_id !== null &&
          groupedNotification[0].main_component_id ===
            newNotification.main_component_id
      );
      if (existNotificationIndex >= 0) {
        let updatedGroupedNotification = [
          ...notifications[existNotificationIndex],
          newNotification,
        ];
        updatedGroupedNotification.sort((a, b) => b.time - a.time).slice(0, 5);
        notifications[existNotificationIndex] = updatedGroupedNotification;
      } else {
        notifications.splice(0, 0, [newNotification]);
      }

      if (notifications && notifications.length > 200) {
        notifications?.splice(-1);
      }
    }
  );
};
